import { html } from 'htm/preact';
import { useState } from 'preact/hooks';

const Toggle = ({ name, options, onChange }) => {
  const [selected, setSelected] = useState(options[0]);

  const handleOnChange = (option) => {
    setSelected(option);
    onChange(option);
  };

  return html`
    <fieldset class="flex bg-white rounded-4xl p-1">
      <legend class="sr-only">${name}</legend>
      ${options.map(
        (option, index) => html`
          <div class="relative flex flex-1">
            <input
              type="radio"
              class="absolute opacity-0 peer"
              name="${name}"
              value="${option}"
              id="${name}_${index}"
              checked=${selected === option}
              onChange=${() => handleOnChange(option)}
            />
            <label
              class="flex-1 rounded-4xl px-4 py-2 cursor-pointer text-center text-xs peer-checked:bg-yellow transition duration-200 md:duration-500 hover:border-gray-400 peer-focus-visible:outline-dashed peer-focus-visible:outline-2 peer-focus-visible:outline-offset-4 peer-focus-visible:outline-purple"
              for="${name}_${index}"
            >
              <span>${option}</span>
            </label>
          </div>
        `,
      )}
    </fieldset>
  `;
};

export default Toggle;
